import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { AccountService } from '../../../services/account.service';
import { RecursosBudget } from '../recursos-budget/recursos-budget';
import { ActivitiesBudget } from '../activities-budget/activities-budget';
import { Budget } from '../../../pages/budget/budget';
import { BudgetVersion } from '../budget-version/budget-version';
import { Activities } from '../../activities/activities';

interface NavItem {
  item: number;
  name: string;
  active: boolean;
}

@Component({
  selector: 'app-nav-budget',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    RecursosBudget,
    Activities,
    BudgetVersion,
  ],
  templateUrl: './nav-budget.html',
  styleUrls: ['./nav-budget.css'],
})
export class NavBudget {
  public accService = inject(AccountService);
  private route = inject(ActivatedRoute);

  public navItems: NavItem[] = [
    { item: 0, name: 'Recursos', active: true },
    { item: 1, name: 'Actividad', active: false },
    { item: 2, name: 'Historial de presupuesto', active: false },
  ];

  @Input() presupuesto_id!: string;

  ngOnInit() {
    console.log('ID recibido en NavBudget:', this.presupuesto_id);
  }

  triggerAction(action: number): void {
    this.navItems = this.navItems.map((item, index) => ({
      ...item,
      active: index === action,
    }));

    this.handleAdditionalActions(action);
  }

  private handleAdditionalActions(action: number): void {
    switch (action) {
      case 2:
        break;
      case 3:
        break;
    }
  }
}
